"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WARN = exports.TRACE = exports.INFO = exports.FastackLogLevel = exports.FATAL = exports.ERROR = exports.DEBUG = void 0;
var _pino = _interopRequireDefault(require("pino"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * A Typescript enum with all of the log levels available on {@link LogApi.LogApi | LogApi}.
 * Beyond the extra Typescript support, it might also be useful if you want to
 * put the level names under a namespace.
 *
 * @example
 * ```
 * import {FastackLogLevel as Level} from "@aops-trove/fast-log/Levels";
 *
 * function assertLogIsNotError(logObj) {
 *   expect(logObj.level).toBeLessThan(Level.ERROR);
 * }
 * ```
 */
let FastackLogLevel = exports.FastackLogLevel = function (FastackLogLevel) {
  FastackLogLevel[FastackLogLevel["FATAL"] = _pino.default.levels.values.fatal] = "FATAL";
  FastackLogLevel[FastackLogLevel["ERROR"] = _pino.default.levels.values.error] = "ERROR";
  FastackLogLevel[FastackLogLevel["WARN"] = _pino.default.levels.values.warn] = "WARN";
  FastackLogLevel[FastackLogLevel["INFO"] = _pino.default.levels.values.info] = "INFO";
  FastackLogLevel[FastackLogLevel["DEBUG"] = _pino.default.levels.values.debug] = "DEBUG";
  FastackLogLevel[FastackLogLevel["TRACE"] = _pino.default.levels.values.trace] = "TRACE";
  return FastackLogLevel;
}({});
/**
 * Alias for `pino.levels.values.fatal` from
 * [pino](https://github.com/pinojs/pino/tree/main). Also available under
 * {@link FastackLogLevel}.
 */
const FATAL = exports.FATAL = FastackLogLevel.FATAL;

/**
 * Alias for `pino.levels.values.error` from
 * [pino](https://github.com/pinojs/pino/tree/main). Also available under
 * {@link FastackLogLevel}.
 */
const ERROR = exports.ERROR = FastackLogLevel.ERROR;

/**
 * Alias for `pino.levels.values.warn` from
 * [pino](https://github.com/pinojs/pino/tree/main). Also available under
 * {@link FastackLogLevel}.
 */
const WARN = exports.WARN = FastackLogLevel.WARN;

/**
 * Alias for `pino.levels.values.info` from
 * [pino](https://github.com/pinojs/pino/tree/main). Also available under
 * {@link FastackLogLevel}.
 */
const INFO = exports.INFO = FastackLogLevel.INFO;

/**
 * Alias for `pino.levels.values.debug` from
 * [pino](https://github.com/pinojs/pino/tree/main). Also available under
 * {@link FastackLogLevel}.
 */
const DEBUG = exports.DEBUG = FastackLogLevel.DEBUG;

/**
 * Alias for `pino.levels.values.trace` from
 * [pino](https://github.com/pinojs/pino/tree/main). Also available under
 * {@link FastackLogLevel}.
 */
const TRACE = exports.TRACE = FastackLogLevel.TRACE;
//# sourceMappingURL=Levels.js.map